import { io, type Socket } from 'socket.io-client';
import { env } from './env';

export interface ChatMessage {
  id: string;
  bookingId: string;
  senderId: string;
  senderRole: 'parent' | 'tutor';
  body: string;
  createdAt: string;
}

export type MessageHandler = (msg: ChatMessage) => void;
export type HistoryHandler = (msgs: ChatMessage[]) => void;
export type ErrorHandler = (err: { message: string }) => void;

export class ChatSocket {
  private socket: Socket;

  constructor(accessToken: string) {
    const wsUrl = env.VITE_PORTAL_API_URL.replace(/^http/, 'ws');
    this.socket = io(`${wsUrl}/chat`, {
      query: { token: accessToken },
      transports: ['websocket'],
      autoConnect: false,
    });
  }

  connect() {
    this.socket.connect();
    return this;
  }

  disconnect() {
    this.socket.disconnect();
  }

  joinRoom(bookingId: string) {
    this.socket.emit('join_room', { bookingId });
    return this;
  }

  sendMessage(bookingId: string, body: string) {
    this.socket.emit('send_message', { bookingId, body });
  }

  onHistory(handler: HistoryHandler) {
    this.socket.on('history', handler);
    return this;
  }

  onMessage(handler: MessageHandler) {
    this.socket.on('message', handler);
    return this;
  }

  onError(handler: ErrorHandler) {
    this.socket.on('error', handler);
    return this;
  }

  onConnect(handler: () => void) {
    this.socket.on('connect', handler);
    return this;
  }

  offAll() {
    this.socket.removeAllListeners();
  }
}
